export enum PasswordStatus {
    ENABLE = 'enable',
    DISABLE = 'disable'
}